import React from 'react'
import PropTypes from 'prop-types'

const InfinityScroll = ({ children, setInfinityRef, className }) =>
  <div className={ className } ref={ setInfinityRef } >
    { children }
  </div>

export default InfinityScroll

InfinityScroll.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  setInfinityRef: PropTypes.func

}
